import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Box from "../../elements/box/Box";
import ButtonPrimary from "../../elements/button/ButtonPrimary";
import InputSingle from "../../elements/input/InputSingle";
import SMSelect from "../../elements/select/SMSelect";
import DatePicker from "react-datepicker";
import { Formik } from "formik";
import * as Yup from "yup";
import axiosAPI from "../../utils/axios-api";

const DataSchema = Yup.object().shape({
  namaKuis: Yup.string().required("Nama kuis dibutuhkan"),
  bentuk: Yup.string().required("Bentuk dibutuhkan"),
  sifat: Yup.string().required("Sifat dibutuhkan"),
  nilaiScoin: Yup.string().required("Scoin kosong"),
  poin: Yup.string().required("Poin kosong"),
  keterangan: Yup.string().required("Keterangan dibutuhkan"),
});

const API = process.env.REACT_APP_API;

export default function BuatKuis() {
  const history = useHistory();
  const today = new Date();
  const tomorrow = new Date(today);
  const userData = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};

  // console.log(userData)
  // Form
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(
    tomorrow.setDate(tomorrow.getDate() + 1)
  );
  const [namaKuis, setnamaKuis] = useState("");
  const [bentuk, setbentuk] = useState("");
  const [sifat, setsifat] = useState("");
  const [nilaiScoin, setnilaiScoin] = useState(0);
  const [poin, setpoin] = useState(10);
  const [keterangan, setketerangan] = useState("");

  const [namaFilePanduan, setnamaFilePanduan] = useState(null);
  const [loadingUploadFile, setloadingUploadFile] = useState(false);
  const [filePanduan, setfilePanduan] = useState(null);

  let data_bentuk = [
    { value: "0", label: "Pilihan Ganda" },
    { value: "1", label: "File" },
    { value: "2", label: "Liklert" },
  ];
  let data_sifat = [
    { value: "0", label: "Terbuka" },
    { value: "1", label: "Tertutup" },
  ];

  const ExampleCustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <button className="example-custom-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  useEffect(() => {
    localStorage.removeItem("temp_create_kuesioner");
  }, []);

  async function createKuesioner(params) {
    let dataKuesioner = {
      // pemilik: userData?.nama,
      tanggal_buka: new Date(startDate).toISOString().split("T")[0],
      tanggal_tutup: new Date(endDate).toISOString().split("T")[0],
      judul: namaKuis,
      tipe: bentuk,
      sifat: sifat,
      scoin: nilaiScoin,
      poin: poin,
      keterangan: keterangan,
      file_panduan: namaFilePanduan,
    };
    await localStorage.setItem(
      "temp_create_kuesioner",
      JSON.stringify(dataKuesioner)
    );

    if (bentuk === "0") {
      history.push("/buat/buat-kuesioner-pilihan-ganda");
    } else if (bentuk === "1") {
      history.push("/buat/buat-kuesioner-file");
    } else if (bentuk === "2") {
      history.push("/buat/buat-kuesioner-liklert");
    }
  }

  function onFileChange(params) {
    uploadFile(params.target.files[0]);
  }

  function uploadFile(params) {
    setloadingUploadFile(true);
    const formData = new FormData();

    formData.append("file", params);

    axiosAPI
      .post(API + "file/upload/panduan", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          setloadingUploadFile(false);
          setnamaFilePanduan(res.data.data.nama_file);
          localStorage.setItem("temp_panduan_file", res.data.data.nama_file);
        }
      })
      .catch((err) => {
        setloadingUploadFile(false);
      });
  }
  return (
    <Box>
      <div className="flex flex-col">
        <div className="w-full flex flex-row pb-6">
          <h1 className="text-2xl mr-4 font-bold">Buat Kuesioner</h1>
        </div>
        
        <Formik
          initialValues={{
            // pemilik: userData?.nama,
            buka: startDate,
            tutup: new Date(endDate),
            namaKuis: namaKuis,
            bentuk: bentuk,
            sifat: sifat,
            nilaiScoin: nilaiScoin,
            poin: poin,
            keterangan: keterangan,
          }}
          enableReinitialize
          validationSchema={DataSchema}
          onSubmit={(values, formikActions) => {
            createKuesioner();
          }}
        >
          {(props) => (
            <>
              <div className="flex flex-row">
                <div className="w-8/12 grid grid-flow-row grid-cols-3 grid-rows-2 gap-4">
                  <div className="flex flex-col">
                    <p className="text-md my-1">Pemilik</p>
                    <InputSingle
                      value={userData?.nama}
                      placeholder="e.g schoolmedia"
                      disable
                    />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-md my-1">Pilih tanggal</p>
                    <div className="flex flex-row">
                      <div className="w-1/2">
                        <p>Buka</p>
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          selectsStart
                          startDate={startDate}
                          minDate={new Date()}
                          endDate={endDate}
                          customInput={<ExampleCustomInput />}
                        />
                      </div>
                      <div className="w-1/2">
                        <p>Tutup</p>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          selectsEnd
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate}
                          customInput={<ExampleCustomInput />}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Nama Kuis */}
                  <div className="flex flex-col">
                    {props.touched.namaKuis && props.errors.namaKuis ? (
                      <p className="text-md my-1 text-red-500">
                        {props.errors.namaKuis}
                      </p>
                    ) : (
                      <p className="text-md my-1">Nama Kuis</p>
                    )}
                    <InputSingle
                      placeholder="e.g schoolmedia"
                      onChange={(e) => setnamaKuis(e.target.value)}
                    />
                  </div>

                  {/* Bentuk Kuis */}
                  <div className="flex flex-col">
                    {props.touched.bentuk && props.errors.bentuk ? (
                      <p className="text-md my-1 text-red-500">
                        {props.errors.bentuk}
                      </p>
                    ) : (
                      <p className="text-md my-1">Bentuk</p>
                    )}
                    <SMSelect
                      data={data_bentuk}
                      onChange={(e) => setbentuk(e.value)}
                    />
                  </div>
                  <div className="flex flex-col">
                    {props.touched.sifat && props.errors.sifat ? (
                      <p className="text-md my-1 text-red-500">
                        {props.errors.sifat}
                      </p>
                    ) : (
                      <p className="text-md my-1">Sifat</p>
                    )}
                    <SMSelect
                      data={data_sifat}
                      onChange={(e) => setsifat(e.value)}
                    />
                  </div>

                  {/* scoin dan poin */}
                  <div className="grid grid-flow-row grid-cols-2 gap-1">
                    <div className="flex flex-col">
                      {props.touched.nilaiScoin && props.errors.nilaiScoin ? (
                        <p className="text-md my-1 text-red-500">
                          {props.errors.nilaiScoin}
                        </p>
                      ) : (
                        <p className="text-md my-1">Nilai Scoin</p>
                      )}
                      <InputSingle
                        placeholder="5"
                        type="number"
                        value={nilaiScoin}
                        onChange={(e) => {
                          if (!(e.target.value < 0)) {
                            setnilaiScoin(e.target.value)
                          }
                        }}
                      />
                    </div>

                    <div className="flex flex-col">
                      {props.touched.poin && props.errors.poin ? (
                        <p className="text-md my-1 text-red-500">
                          {props.errors.poin}
                        </p>
                      ) : (
                        <p className="text-md my-1">Poin</p>
                      )}
                      <InputSingle
                        placeholder="10"
                        type="number"
                        value={poin}
                        onChange={(e) => {
                          if (!(e.target.value < 0)) {
                            setpoin(e.target.value)
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Keterangan */}
                <div className="w-4/12 flex flex-col px-4">
                  {props.touched.keterangan && props.errors.keterangan ? (
                    <p className="text-md my-1 text-red-500">
                      {props.errors.keterangan}
                    </p>
                  ) : (
                    <p className="text-md my-1">Keterangan</p>
                  )}
                  <textarea
                    className="text-black text-sm bg-gray-200 dark:text-gray-200 dark:bg-gray-600 p-1 rounded-lg mb-4"
                    id="w3review"
                    name="w3review"
                    rows="3"
                    cols="50"
                    onChange={(e) => setketerangan(e.target.value)}
                  ></textarea>
                  <div className="w-full mb-2">
                    {!!namaFilePanduan ? (
                      <p>Nama file panduan: {namaFilePanduan}</p>
                    ) : null}
                    {loadingUploadFile ? (
                      <ButtonPrimary text="Loading" type="outline" />
                    ) : (
                      <div className="w-full flex flex-1">
                        <input
                          type="file"
                          accept="application/pdf, application/vnd.ms-excel, .xlsx, .xls, .csv, .docx"
                          name="file"
                          id="file"
                          className="none"
                          style={{ display: "none" }}
                          onChange={(e) => onFileChange(e)}
                        />
                        <label
                          className="w-full text-center cursor-pointer px-4 py-2 rounded text-blue-500 border-blue-500 border bg-white dark:bg-gray-800"
                          htmlFor="file"
                          for="file"
                        >
                          Upload File Panduan
                        </label>
                      </div>
                    )}
                  </div>
                  <ButtonPrimary
                    text="Buat Kuis"
                    type="solid"
                    onClick={(e) => props.handleSubmit()}
                  />
                  {/* <Link to="/buat/buat-instrumen">
                    <ButtonPrimary text="Buat Kuis" type="solid" />
                  </Link> */}
                </div>
              </div>
            </>
          )}
        </Formik>
      </div>
    </Box>
  );
}
